import { RoundsReportData, GlobalReportData, ReportsState } from '../models'

/**
 * ROUNDS INITIAL VALUES
 */
export const initialRoundsReport: RoundsReportData = {
  betId: 0,
  balanceAfter: '',
  bonusMoneyBet: '',
  bonusMoneyWin: '',
  creditTime: '',
  currency: '',
  debitTime: '',
  game: 0,
  gameCategory: 0,
  gameProvider: 0,
  playerId: 0,
  username: '',
  limit: 0,
  page: 0,
  transactionTypePayment: 0,
  providerRoundId: '',
  providerTransactionId: '',
  internalTransactionId: '',
}

/**
 * GLOBAL INITIAL VALUES
 */
export const initialGlobalReport: GlobalReportData = {
  bets: '',
  wins: '',
  totalBets: 0,
  totalWins: 0,
  creditTime: '',
  currency: '',
  debitTime: '',
  game: 0,
  name: '',
  playerId: 0,
  username: '',
  gameWin: '',
  rounds: '',
  rtp: '',
  totalBonusCost: 0,
  limit: 0,
  page: 0,
}

/**
 * REPORTS INITIAL STATE
 */
const initialState: ReportsState = {
  isLoading: false,
  hasError: false,
  error: '',
  wasDeleted: false,
  globalReports: [],
  globalPagination: {
    total: 0,
    limit: 25,
    page: 1,
    pages: 1,
  },
  roundsReports: [],
  roundsPagination: {
    total: 0,
    limit: 25,
    page: 1,
    pages: 1,
  },
  filters: {
    reportType: '',
    game: '',
    gameCategory: '',
    gameProvider: '',
    transactionsDateRange: '',
    page: 1,
    limit: 25,
  },
}

export default initialState
